import { GRAMMAR, PLAGIARISM } from '@src/components/Cards/constants'
import { EXPERT_CHECK } from '@src/state/document/types'
import { CHEGG, SiteState } from '@src/state/site/types'
import { ClickstreamInteractionPayload } from '@src/state/userevents/actions'
import { viewExperienceMap } from '../constants'
import { BUSINESS_UNIT } from '../types'

interface GetUpdatedViewParams {
  site: SiteState
  page: string
}

export function getUpdatedView({ site, page }: GetUpdatedViewParams) {
  const property = site === CHEGG ? CHEGG : BUSINESS_UNIT
  return {
    property,
    experience: viewExperienceMap[site],
    view_name: page,
  }
}

export const getInteractionElementName = ({
  origin,
  element,
}: Omit<ClickstreamInteractionPayload, 'type' | 'interactionType'>) => {
  if (origin === 'navtab') {
    switch (element) {
      case GRAMMAR:
        return 'grammar check navigation'
      case PLAGIARISM:
        return 'plagiarism check navigation'
      case EXPERT_CHECK:
        return 'expert check navigation'
    }
  }
  return element
}



// WEBPACK FOOTER //
// ./src/state/analytics/utils/index.ts